/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DevicesRemoveActionAliases {
  AUTOC_REASON_REMOVE_ITEM = 'autoc-reason-remove-item',
  AUTOC_REMOVE_ACTION_ITEM = 'autoc-remove-action-item',
  CONTEXTUAL_BAR_REMOVE_ACTION_MENU = 'contextual-bar-remove-action-menu',
  DESCRIPTION_FIELD = 'description-field',
  DESCRIPTION_TEXT_AREA = 'description-text-area',
  DYNAMIC_FIELDS = 'dynamic-fields',
  FETCH_REASON_REMOVE_ITEM = 'fetch-reason-remove-item',
  FETCH_REMOVE_ACTION_ITEM = 'fetch-remove-action-item',
  FIELD_DATE = 'field-date',
  FIELD_DEVICE_DESCRIPITION = 'field-device-descripition',
  FIELDSET_DYNAMIC_FIELDS = 'fieldset-dynamic-fields',
  FILTER_FIELD_REASON_REMOVE = 'filter-field-reason-remove',
  FILTER_FIELD_REMOVE_ACTI = 'filter-field-remove-acti',
  FORM_DEVICES_REMOVE_ACTION_VIEWER = 'form-devices-remove-action-viewer',
  INFORMATION_BAR_HEADER_FRAGMENT_REMOVE = 'information-bar-header-fragment-remove',
  INPUT_DATE = 'input-date',
  LAYOUT_DEVICES_REMOVE_ACTION = 'layout-devices-remove-action',
  MAPPER_REASON_REMOVE_ITEM = 'mapper-reason-remove-item',
  MAPPER_REMOVE_ACTION_ITEM = 'mapper-remove-action-item',
  PANEL_HEADER_REMOVE = 'panel-header-remove',
  TEXT_DEVICE_DESCRIPITION = 'text-device-descripition',
  TEXT_REASON_REMOVE_ITEM = 'text-reason-remove-item',
  TEXT_REMOVE_ACT_ITEM = 'text-remove-act-item',
}
export { DevicesRemoveActionAliases };
